import { GET_ORGANISATIONS, GET_ORGANISATION_DETAILS, GET_NETWORKS } from "../actions/types";

const initialState = {
  organisations: [],
  organisationDetails: {},
  networks: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ORGANISATIONS: 
      return {
        ...state,
        organisations: action.payload
      }
    case GET_ORGANISATION_DETAILS: 
      return {
        ...state,
        organisationDetails: {
          ...state.organisationDetails,
          ...action.payload,
        }
      }
    case GET_NETWORKS:
      return {
        ...state,
        networks: action.payload,
      }
    default: {
      return state;
    }
  }
}